import React from 'react';
import { CloseIcon, MinusIcon, PlusIcon, ArrowLeft } from '../../public/icons';
import { MemoryMagnet } from '../../public/images/home';

const OrderSummaryModal = ({
  isOpen,
  onClose,
  onBack,
  onAddToBag,
  onRemoveFromBag,
  isInCart = false,
  customizationData,
  extrasData,
  futureGiftData
}) => {
  if (!isOpen) return null;

  const basePrice = 320000;
  const shippingFee = 5000;
  const futureGiftAdditionalMagnet = 20000;
  const futureGiftDigitalMemory = 25000;

  const subtotal =
    basePrice + futureGiftAdditionalMagnet + futureGiftDigitalMemory;
  const total = subtotal + shippingFee;

  return (
    <>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-[100] transition-opacity duration-300"
        onClick={onClose}
      />

      <div className="fixed right-0 top-0 h-full w-full md:w-[60%] lg:w-[50%] xl:w-[40%] text-left bg-[#F9F6F2] z-[999] overflow-y-auto transition-transform duration-300 ease-in-out">
        <div className="h-full flex flex-col">
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-6">
            <div className="text-left">
              <h2 className="text-2xl font-bold text-[#1C2A46] mb-1">
                Order Summary
              </h2>
              <p className="text-[#6B635D] text-sm">
                Do you want to make this gift continue in the future?
              </p>
            </div>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded"
            >
              <CloseIcon className="w-6 h-6 text-[#1C2A46]" />
            </button>
          </div>

          <div className="flex-1 overflow-y-auto px-6">
            {/* Product */}
            <div className="flex gap-4">
              <div className="w-24 h-24 bg-gray-200 rounded flex-shrink-0">
                <img
                  src={MemoryMagnet}
                  alt="Frame It Forward Gift box"
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="flex-1">
                <div className="flex justify-between items-start mb-2">
                  <div>
                    <h3 className="font-semibold text-[#1C2A46] text-lg">
                      Frame It Forward Gift box
                    </h3>
                    <p className="text-[#6B635D] text-sm italic mb-3">
                      A frame that holds more than a picture.
                    </p>
                  </div>
                  <span className="font-semibold text-[#1C2A46]">
                    ₦{basePrice.toLocaleString()}
                  </span>
                </div>

                <ul className="space-y-1 text-sm text-[#1C2A46] mb-4">
                  <li>• Memory Magnet Set (4 magnets) x1</li>
                  <li>• Audio Gift x1</li>
                </ul>

                <div className="flex items-center justify-between space-x-4 w-36 p-1.5 border border-[#E0E0E0]">
                  <button className="flex items-center justify-center hover:bg-[#F5F5F5] transition-colors">
                    <MinusIcon className="w-7 h-7 text-[#1C2A46]" />
                  </button>
                  <span className="text-base font-normal text-[#1C2A46] min-w-[3rem] text-center">
                    1 set
                  </span>
                  <button className="rounded-lg flex items-center justify-center hover:bg-[#F5F5F5] transition-colors">
                    <PlusIcon className="w-7 h-7 text-[#1C2A46]" />
                  </button>
                </div>

                <div className="mb-8 bg-[#F5F5F5] mt-5 px-2.5 py-3">
                  <h3 className="text-lg font-semibold text-[#1C2A46] mb-4">
                    Future Gift Scheduled
                  </h3>

                  <div className="space-y-3 mb-4">
                    <div className="flex justify-between items-center">
                      <span className="text-[#1C2A46]">
                        • Additional Memory magnet (4 magnets)
                      </span>
                      <span className="text-[#1C2A46] font-medium">
                        ₦{futureGiftAdditionalMagnet.toLocaleString()}
                      </span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-[#1C2A46]">• Digital Memory</span>
                      <span className="text-[#1C2A46] font-medium">
                        ₦{futureGiftDigitalMemory.toLocaleString()}
                      </span>
                    </div>
                  </div>

                  <div className="bg-[#FCF7EE] border-2 border-dashed p-1">
                    <div className="text-sm text-[#1C2A46] font-normal mb-1">
                      <span className="font-medium text-[#6B635D]">
                        Reveal On:
                      </span>{' '}
                      Thursday, January 29, 2026
                    </div>
                    <p className="text-sm font-light text-[#6B635D]">
                      You can add content for this gift later in your account
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Totals */}
            <div className="space-y-4 pt-1 border-t border-[#DBDBDB]">
              <div className="flex justify-between items-center text-[#1C2A46]">
                <span className="text-base font-normal text-[#6B635D]">
                  Subtotal
                </span>
                <span className="text-lg text-[#1C2A46] font-normal">
                  ₦{subtotal.toLocaleString()}
                </span>
              </div>
              <div className="flex justify-between items-center text-[#1C2A46]">
                <span className="text-base font-normal text-[#6B635D]">
                  Shipping Fee
                </span>
                <span className="text-lg text-[#1C2A46] font-normal">
                  ₦{shippingFee.toLocaleString()}
                </span>
              </div>
              <div className="flex justify-between items-center text-[#1C2A46] text-xl font-bold pt-3.5 border-t border-[#DBDBDB]">
                <span className="text-base text-[#1C2A46] font-normal">
                  Total
                </span>
                <span className="text-lg text-[#1C2A46] font-medium">
                  ₦{total.toLocaleString()}
                </span>
              </div>
            </div>
          </div>

          {/* Footer — switches between Add and Added+Remove */}
          <div className="p-6 flex gap-4">
            <button
              onClick={onBack}
              className="flex w-1/4 justify-center items-center py-3 font-medium border border-[#DBDBDB] text-[#1C2A46] hover:border-[#D2A146] transition-colors"
            >
              <ArrowLeft />
              Back
            </button>

            {isInCart ? (
              <>
                <button
                  disabled
                  className="flex-1 py-3 font-medium bg-[#2F8F5B] text-white cursor-default"
                >
                  Added to Bag
                </button>
                <button
                  onClick={onRemoveFromBag}
                  className="flex-1 py-3 font-medium border border-[#A82121] text-[#A82121] hover:bg-[#A82121] hover:text-white transition-colors"
                >
                  Remove from bag
                </button>
              </>
            ) : (
              <button
                onClick={onAddToBag}
                className="flex-1 py-3 font-medium bg-[#D2A146] text-white hover:bg-[#C49660] transition-colors"
              >
                Save & Continue
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderSummaryModal;